import React from 'react';
import { CheckCircle, Users, Award } from 'lucide-react';

const SocialProofSection = () => {
  const stats = [
    {
      number: "40+",
      label: "Hours Saved",
      description: "Per week on manual reporting"
    },
    {
      number: "80%",
      label: "Cost Reduction",
      description: "In admin overhead expenses"
    },
    {
      number: "2x",
      label: "Faster Decisions",
      description: "With real-time insights"
    }
  ];

  return (
    <section className="py-20 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Trusted by 10+ CPA Firms
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join growing firms that have transformed their practice management with real results
          </p>
        </div>
        
        {/* Stats Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {stats.map((stat, index) => (
            <div key={index} className="text-center p-8 bg-gray-50 rounded-xl border border-gray-100">
              <div className="text-4xl font-bold text-orange-500 mb-2">
                {stat.number}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {stat.label}
              </h3>
              <p className="text-gray-600">
                {stat.description}
              </p>
            </div>
          ))}
        </div>
        
        {/* Trust Indicators */}
        <div className="max-w-4xl mx-auto">
          <div className="bg-gray-50 rounded-xl p-8 border border-gray-100">
            <div className="flex items-center justify-center mb-6">
              <Users className="w-8 h-8 text-blue-600 mr-3" />
              <h3 className="text-2xl font-bold text-gray-900">Proven Results</h3>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">Quick Setup</p>
                  <p className="text-sm text-gray-600">1-2 week implementation</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">Secure Integration</p>
                  <p className="text-sm text-gray-600">Data stays within your infrastructure</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">No Disruption</p>
                  <p className="text-sm text-gray-600">Works with existing Practice CS</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-500 mt-1" />
                <div>
                  <p className="font-semibold text-gray-900">Dedicated Support</p>
                  <p className="text-sm text-gray-600">Personal onboarding and training</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProofSection;